import React, { useState, useRef, useEffect } from 'react'
import Richtext from '../atoms/Richtext'
import OneColWrapper from '../technical/OneColWrapper'
import Image from '../atoms/Image'
import Headline from '../atoms/Headline'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import SocialShareBlock from './SocialShareBlock'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import SbEditable from 'storyblok-react'
import Modal from 'react-modal'
import { Helmet } from 'react-helmet'
import Video from '../atoms/Video'

gsap.registerPlugin(ScrollTrigger)

// TODO: nav-links scroll-to

const HeroBlock = ({ block, gravity, useStoryblokImage }) => {
  const refHeroScroll = useRef(null)
  const [modalIsOpen, setIsOpen] = useState(false)

  const openModal = (e) => {
    e.preventDefault()
    setIsOpen(true)
  }
  const closeModal = (e) => {
    e.preventDefault()
    setIsOpen(false)
  }

  useEffect(() => {
    gsap.from(refHeroScroll.current, {
      //duration: 1,
      ease: 'power1.out',
      scrollTrigger: {
        trigger: refHeroScroll.current,
        toggleActions: 'play none none none',
        start: 'top -40px',
        end: 99999,
        toggleClass: 'scrolled-state',
      },
    })
  }, [])

  let hasImage = false
  if (
    block.image?.filename?.length > 0 ||
    block.image?.src?.length > 0 ||
    block.image?.length > 0
  ) {
    hasImage = true
  }

  return (
    <>
      <SbEditable content={block}>
        {hasImage ? (
          <section
            ref={refHeroScroll}
            className={`hero ${
              block.reduced_height === true ? 'kn-micro-hero' : ''
            } ${
              block.hero_variant_class
                ? block.hero_variant_class
                : 'kn-standard-hero'
            } ${block.hero_mirrored && 'hero-mirrored'}`}
          >
            <article className="hero-content">
              <div className="hero-image-container">
                <div className="hero-image">
                  <div className="hero-image-overlay" />
                  <div data-rellax={true} data-rellax-speed={-5}>
                    <Image
                      className={`img-fluid ${
                        block?.reduced_height ? 'img-reduced-height' : ''
                      }`}
                      image={block.image}
                      alt={block.alt}
                      //imageWidth="1397"
                      //imageHeight={block?.reduced_height ? '590' : '786'}
                      gravity={gravity}
                      useStoryblokImage={useStoryblokImage}
                      //forceLoad={true}
                    />
                  </div>
                  {block.hero_variant_class === 'kn-product-hero' &&
                    block.video_url?.length > 0 && (
                      <div className="hero-play-button" onClick={openModal}>
                        <i className="fas fa-play"></i>
                      </div>
                    )}
                </div>
              </div>
              {block.headline?.length > 0 && (
                <div className="hero-text-overlay">
                  <div className="hero-text-container">
                    <div className="hero-text">
                      <div className="hero-text-inner">
                        <Headline
                          kicker={block.kicker}
                          headline={block.headline}
                          subheadline={block.subheadline}
                          headline_level="h1"
                          tagName="h1"
                        />
                      </div>
                    </div>
                    {block.meta_nav_items?.length > 0 && (
                      <div className="hero-meta-nav">
                        <div className="hero-meta-nav-inner">
                          <ul className="nav flex-column">
                            {block.meta_nav_items.map((item, index) => (
                              <li className="nav-item" key={index}>
                                <AnchorLink
                                  className="nav-link"
                                  offset="100"
                                  href={item.url}
                                >
                                  <span>{item.title}</span>
                                </AnchorLink>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                  {block.hero_variant_class === 'kn-product-hero' && (
                    <SocialShareBlock variant="social-share-block-hero-embed" />
                  )}
                </div>
              )}
              {block.video_url && block.video_url.length > 0 && (
                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  style={{
                    overlay: {
                      backgroundColor: 'rgba(0,0,0,.5)',
                      zIndex: '1060',
                    },
                    content: {
                      background: 'transparent',
                      border: 'none',
                      inset: '0',
                      padding: '1.5rem',
                    },
                  }}
                >
                  <Helmet bodyAttributes={{ class: 'overflow-hidden' }} />
                  <div className="modal-inner">
                    <div className="modal-header">
                      <h4 className="modal-title" id="spa-modal-label">
                        {block.headline}
                      </h4>
                      <input
                        className="btn btn-close"
                        type="button"
                        value=""
                        onClick={(e) => closeModal(e)}
                      />
                    </div>
                    <div className="modal-body">
                      <div className="figmedia">
                        <Video
                          video={
                            block.video_url + '?badge=0&autoplay=1&html5=1'
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Modal>
              )}
            </article>
          </section>
        ) : (
          <>
            <section
              className="skewed-block"
              data-rellax={true}
              data-rellax-speed={-3}
            >
              <div className="skewed-block-space"></div>
              <div className="skewed-block-effect"></div>
            </section>
            <section
              className={`article-header-block ${
                block.intro?.length > 0 && 'pb-2'
              } `}
            >
              <div className="article-header-block-container">
                {block.category?.length > 0 && (
                  <p className="meta-category">{block.category}</p>
                )}
                {block.date?.length > 0 && (
                  <p className="meta-timestamp">{block.date}</p>
                )}
                {block.headline?.length > 0 ? (
                  <h1 className="text-center">{block.headline}</h1>
                ) : (
                  <h1 className="text-center">{block.name}</h1>
                )}
              </div>
            </section>
          </>
        )}

        {block.intro?.length > 0 && (
          <OneColWrapper block={{}} className="pt-0">
            <Richtext text={block.intro} />
          </OneColWrapper>
        )}
      </SbEditable>
    </>
  )
}

export default HeroBlock
